module.exports = __webpack_public_path__ + "static/media/tire-at-shop.c63efcb4.svg";